import { RoutePermittedRole } from '../../constants/src/AppEnums';

const DefaultRoutesConfig = [
  {
    id: 'default',
    title: '기본정보',
    messageId: 'sidebar.default',
    type: 'collapse',
    children: [
      {
        id: 'myPage',
        title: '마이 페이지',
        messageId: 'common.myPage',
        type: 'item',
        permittedRole: [RoutePermittedRole.User, RoutePermittedRole.Admin],
        url: '/myPage',
        // icon: <MdOutlineAnalytics />,
      },
    ],
  },
];

export default DefaultRoutesConfig;
